export default "__VITE_ASSET__Bchjaxo5__"